import * as Yup from 'yup'

const regExpresionValidName = /^[A-Za-záÁéÉíÍóÓúÚñÑ ]+$/

export const contactStepFormSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, 'El nombre es demasiado breve: debe tener al menos tres caracteres')
    .matches(regExpresionValidName, 'El nombre debe tener solo letras')
    .required('Nombre obligatorio'),
  email: Yup.string()
    .email('El email no es valido')
    .required('Email obligatorio'),
})



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/BroadcastForm/ContactStep/ContactStepForm/ContactStepForm.validator.ts